import { createContext, useContext } from "react";
import pl from "../messages/pl";

export const TranslationContext = createContext(pl);

export const useTranslation = () => {
    return useContext(TranslationContext);
};
